import { PublicClientApplication } from "@azure/msal-browser";

import { useStoreLayout } from "features/layout/store";
import { useStart } from "features/start/fabric";


let msal;

export const useLayout = () => {
	const layout = useStoreLayout();


	const redirect = "/";
	return { ...layout, redirect };
};

export const useLayoutMsal = () => {
	const start = useStart();

	if (!msal && start.settings) {
		const msalOptions = {
			auth: {
				clientId: start.settings.msal.appId,
				authority: `https://login.microsoftonline.com/${start.settings.msal.tenantId}`,
				redirectUri: `https://${location.host}`
			},
			cache: {
				cacheLocation: "localStorage"
			}
		};

		msal = new PublicClientApplication(msalOptions);
	}

	return { msal };
};